export const GIT_COMMIT = '3f4105626816675f4650dae2d03396f44c443733';
